module.exports = __webpack_public_path__ + "img/Dashboard.69f4b59e.jpg";